import React from 'react';
import { Box, Stack, SxProps, Typography } from '@mui/material';
import { IShiftCollection } from './interfaces';

export const ShiftCollection: React.FC<IShiftCollection> = ({
  title,
  color,
  children,
}): JSX.Element => {
  const boxSx: SxProps = (() => {
    if (color || title) {
      return {
        mt: '15px',
        borderRadius: '5px',
        position: 'relative',
        background: '#ecf0f1',
        p: '10px 10px 10px 15px',
        '&:before': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '5px',
          backgroundColor: color,
          borderTopLeftRadius: '5px',
          borderBottomLeftRadius: '5px',
        },
      };
    }

    return {};
  })();

  return (
    <Box sx={boxSx}>
      {title && (
        <Typography
          variant="h2"
          fontSize="16px"
          fontWeight="bold"
          sx={{
            mb: '10px',
          }}
        >
          {title}
        </Typography>
      )}
      <Stack direction="column" gap="5px">
        {children}
      </Stack>
    </Box>
  );
};
